import getCurrentLocale from 'utilities/getCurrentLocale';
import spacetime from 'spacetime';
import { START_OF_DAY } from 'constants/dateFormatOptionConstants';
import { isDateTime } from 'utilities/type/datetime';
import { isUndefined } from 'lodash';
import { DateTime as luxon } from 'luxon';

// given a date and a full timezone, returns a timezone abbrev
// e.g., timezone: "America/New_York" returns "EST"
export const formatTimezone = (ianaTimezone, isoDate) => {
  if (isoDate && ianaTimezone && ianaTimezone.length > 0) {
    return luxon.fromISO(isoDate, { locale: getCurrentLocale() })
      .setZone(ianaTimezone).offsetNameShort;
  }
  // TODO: Capture this case on bugsnag
  return '';
};

/**
 * Snad date to specified time
 *
 * @param {Date} date
 * @param {number} param1 hour
 * @param {number} param2 minute
 * @param {number} param3 seconds
 * @returns {(string|Date)} ISO date string
 */

// @todo spacetime has startOf and endOf methods we could use in place of these configs and methods
export const TIME_OF_DAY_CONFIGURATION = {
  START: {
    hour: 0,
    minute: 0,
    milliseconds: 0,
    seconds: 0
  },
  END: {
    hour: 23,
    minute: 59,
    milliseconds: 999,
    seconds: 59
  }
};

export const snapToISOTime = (date, config) => spacetime(date)
  .hour(config.hour)
  .minute(config.minute)
  .second(config.seconds)
  .milliseconds(config.milliseconds)
  .format('iso');

// returns ISO date
export const snapTimeToMidnight = (date, snapTo = START_OF_DAY) => {
  if (snapTo === START_OF_DAY) {
    return snapToISOTime(date, TIME_OF_DAY_CONFIGURATION.START);
  }
  return snapToISOTime(date, TIME_OF_DAY_CONFIGURATION.END);
};


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
// default output is D/M/YYYY for en-US
const formatDate = (dateTime, formatOptions = {}, forceLocale = undefined) => {
  const locale = forceLocale || getCurrentLocale();

  // this approach can parse an ISO 8601 string before applying formatting
  return new Intl.DateTimeFormat(locale, formatOptions).format(new Date(dateTime));
};

// @todo can't come up with a better name (SPACEtime goTO timeZONE)
export const spaceToZone = (date, timezone) => {
  if (!isDateTime(date)) {
    throw new Error('Invalid Date');
  }
  if (!timezone || timezone === null || isUndefined(timezone)) {
    throw new Error('Timezone is not defined');
  }

  const parsedDatetime = luxon.fromISO(date).setZone(timezone).toString();
  // spacetime is being wonky, so let Luxon do the parsing
  // then convert to spacetime
  return spacetime(parsedDatetime, timezone);
};


export default formatDate;
